import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { CardLink } from "reactstrap";
import { createBrowserHistory } from 'history';

interface IProps {
	onClick?: any;
}

interface IState {
}

class DABBackToList extends React.Component<IProps, IState>{

	constructor(props: any) {
		super(props);
		this.handleOnClick = this.handleOnClick.bind(this);
	}

	handleOnClick(event) {
		if (this.props.onClick) {
			const history = createBrowserHistory();
			history.goBack();
		}
	}
	

	render() {
		return (
			<div className='card-box-link-back-div'>
				<FontAwesomeIcon icon={faChevronLeft} />
				<CardLink onClick={this.handleOnClick} className='card-box-link-back' data-testid="bible-backtolist">
					Back to List
				</CardLink>
			</div>
		)
	}
}

export default DABBackToList;